import React, { PropTypes } from 'react';
import { months, years } from '../../../../../utils/select-fields';
import Select from 'react-select';
import Dropzone from '../../../../extra/dropzone/dropzone';
import { FontIcon } from 'material-ui';

const InsuranceInfo = (props) => {
  const {
    title,
    insExpMonthError,
    insuranceExpirationMonth,
    insExpYearError,
    insuranceExpirationYear,
    onChange,
    attachedFiles,
    removeFile,
    attachFile,
  } = props;

  const textFieldInfo = [
    {
      name: 'month',
      placeholder: 'Month',
      options: months,
      error: insExpMonthError,
      value: insuranceExpirationMonth,
      onChange: ({ value }) => onChange({ key: 'insuranceExpirationMonth', value }),
    },
    {
      name: 'year',
      placeholder: 'Year',
      options: years,
      error: insExpYearError,
      value: insuranceExpirationYear,
      onChange: ({ value }) => onChange({ key: 'insuranceExpirationYear', value }),
    },
  ];
  const textFieldStyling = { width: '36%', display: 'inline-block' };

  return (
    <div style={{ marginTop: '2%' }}>
      <p style={{ fontWeight: '600', color: '#757575' }}>Insurance expiration</p>
      {textFieldInfo.map((textField, index) => {
        return (
          <div key={index} style={textFieldStyling}>
            <Select
              name={textField.name}
              options={textField.options}
              menuStyle={{ height: '80px' }}
              value={textField.value}
              onChange={textField.onChange}
              placeholder={textField.placeholder}
              clearable={false}
              scrollMenuIntoView={false}
            />
          </div>
        );
      })}
      <div style={{ clear: 'both', marginTop: '8px' }}>
        {attachedFiles && attachedFiles.length && (attachedFiles[0].fileName || attachedFiles[0].name) ? (
          <div style={{ color: '#bfbfbf', fontSize: '12px' }}>
          <label style={{ fontSize: '14px' }}>Insurance document: </label>
            {attachedFiles.map((file, index) =>
              <div
                key={index}
                style={{
                  backgroundColor: 'rgba(0, 126, 255, 0.08)',
                  borderRadius: '2px',
                  border: '1px solid rgba(0, 126, 255, 0.24)',
                  color: '#007eff',
                  display: 'inline-block',
                  fontSize: '0.9em',
                  lineHeight: '1.4',
                  marginLeft: '5px',
                  verticalAlign: 'top',
                }}
              >
                <span
                  onClick={() => removeFile(file)}
                  style={{
                    cursor: 'pointer',
                    borderBottomLeftRadius: '2px',
                    borderTopLeftRadius: '2px',
                    borderRight: '1px solid rgba(0, 126, 255, 0.24)',
                    padding: '1px 5px 3px',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                  }}
                >
                  x
                </span>
                <span
                  style={{
                    color: '#007eff',
                    textDecoration: 'none',
                    borderBottomRightRadius: '2px',
                    borderTopRightRadius: '2px',
                    cursor: 'default',
                    padding: '2px 5px',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                  }}
                >{file.name || file.fileName}</span>
              </div>
            )}
          </div>
          ) :
          (
            <Dropzone
              style={{ border: '1px dotted #bfbfbf', padding: '12px 8px', color: '#bfbfbf', fontSize: '12px', minHeight: '50px', width: '95%' }}
              onDrop={attachFile}
            >
              <FontIcon className="tc-icon-attach_file" color="#bfbfbf" style={{ fontSize: '14px', top: '2px', marginRight: '5px' }} />
              Attach insurance documents by dragging & dropping or <span style={{ color: '#00b3cf', cursor: 'pointer' }}>selecting them. <div style={{ color: 'red' }}>This is required.</div></span>
            </Dropzone>
          )
        }
      </div>
    </div>
  );
};

InsuranceInfo.propTypes = {
  insuranceExpirationMonth: PropTypes.any,
  insuranceExpirationYear: PropTypes.any,
  title: PropTypes.string,
  onChange: PropTypes.func,
  insExpMonthError: PropTypes.string,
  insExpYearError: PropTypes.string,
  attachFile: PropTypes.func,
  attachedFiles: PropTypes.array,
  removeFile: PropTypes.func,
  insuranceFiles: PropTypes.array,
};

export default InsuranceInfo;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/billing/insurance-exp.jsx